module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<div class="detail">\n    ';
 if (item.has('recommend_status') && item.get('recommend_status') != 'Cancelled') { ;
__p += '\n        ' +
((__t = ( item.get('recommend_status') )) == null ? '' : __t) +
' on ' +
((__t = ( item.get('recommend_status_date') )) == null ? '' : __t) +
'\n    ';
 } else if (item.has('link_description')) { ;
__p += '\n        Linked on ' +
((__t = ( item.get('link_date') )) == null ? '' : __t) +
' to ' +
((__t = ( item.get('link_description') )) == null ? '' : __t) +
'\n    ';
 } ;
__p += '\n</div>\n\n<div class="action">\n    ';
 if (item.has('recommend_status') && item.get('recommend_status') == 'Submitted' && item.has('recommend_form_id') && item.get("viewable_permission")) { ;
__p += '\n        <a href="' +
((__t = ( Routes.ad_hoc_form_path(item.get('recommend_form_id')) )) == null ? '' : __t) +
'" target="_blank">View Form</a>\n\n        &middot;\n\n    ';
 } else if (item.get("files").length > 0 && item.get("viewable_permission")) { ;
__p += '\n        <a href="' +
((__t = ( Routes.checklist_answer_manage_uploaded_files_path(item.get('id')) )) == null ? '' : __t) +
'" class="manage-files-modal">Manage\n            Files <i class="fa fa-upload"></i></a>\n    ';
 } else { ;
__p += '\n        ';
 if (item.has('recommend_status') && item.get("viewable_permission")) { ;
__p += '\n            <a href="' +
((__t = ( Routes.checklist_answer_recommendation_request_path(item.get('id')) )) == null ? '' : __t) +
'" class="open-modal">Manage\n                <i class="fa fa-cogs"> <span class="spacer">|</span> </i> </a>\n        ';
 } else if (!item.has('link_description') && item.get("viewable_permission")) { ;
__p += '\n            <a href="' +
((__t = ( Routes.new_checklist_answer_recommendation_request_path(item.get('id')) )) == null ? '' : __t) +
'" class="open-modal">Manage\n                <i class="fa fa-cogs  more-space"> <span class="spacer">|</span> </i> </a>\n        ';
 } ;
__p += '\n        ' +
((__t = ( templateMap['checklist/checklist_form_item']({item: item}) )) == null ? '' : __t) +
'\n\n    ';
 } ;
__p += '\n</div>\n';

}
return __p
}